import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { list4uBusAutomations } from "../../../../../../services/uBusAutomationRobot";

const translationPath = "page.4uBus.uBusAutomationRobot.";

export const BusAutomationSelect = memo(() => {
  const { t } = useTranslation();

  const [options, setOptions] = useState<ISelectType[]>([]);

  const { sendRequest } = useFetch(list4uBusAutomations);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest(undefined);
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: item.id,
          name: item.name,
          code: String(item.code),
        }))
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <AutoComplete
      name="uBusAutomation"
      label={t(translationPath + "ubus_automation")}
      getOptionLabel={(option) => option.name}
      size="small"
      fullWidth
      options={options}
      autoFocus
    />
  );
});
